import React, { useState } from "react";
import Header from "../HomeCompontent/Header";
import Banner from "../HomeCompontent/Banner";
import Footer from "../HomeCompontent/Footer";
import { Outlet } from "react-router-dom";
import Mode from "../HomeCompontent/Mode";
import ScrollToTopWrapper from "../Page/ScrollToTopWrapper";

const MainLayout = () => {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <ScrollToTopWrapper>
      <Header darkMode={darkMode} />
      <Banner darkMode={darkMode} />
      <Outlet context={{ darkMode, setDarkMode }} />
      <Footer darkMode={darkMode} />
      <Mode setDarkMode={setDarkMode} darkMode={darkMode} />
    </ScrollToTopWrapper>
  );
};

export default MainLayout;
